import { render } from "./SalesDetailInput.vue?vue&type=template&id=d8a25e6a"
import script from "./SalesDetailInput.vue?vue&type=script&lang=js"
export * from "./SalesDetailInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__